import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { UnitMultiStepForm } from '../../app/components/unit/unit-multi-step-form';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';

export const Route = createFileRoute('/units/$unitId')({
  component: UnitDetailRoute,
});

function UnitDetailRoute() {
  const { unitId } = Route.useParams();
  const navigate = useNavigate({ from: '/units/$unitId' });
  const utils = trpc.useUtils();
  const { data, isLoading } = trpc.units.get.useQuery({ id: unitId });
  const unit = unwrapTrpcData(data);

  const handleClose = () => {
    navigate({ to: '/units', replace: true });
  };

  const handleSubmit = async () => {
    await utils.units.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title="Edit Unit"
      size="xl"
      centered
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            Loading unit...
          </div>
        ) : unit ? (
          <UnitMultiStepForm
            defaultValues={unit}
            onSubmit={handleSubmit}
            onClose={handleClose}
            isEditing
          />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            Unable to locate unit.
          </div>
        )
      }
      footer={<></>}
    />
  );
}


